export class Analytics {
  static sessionStarted = false;
  static debug = false;

  static init(opts) {
    this.debug = !!(opts && opts.debug);
  }

  static startSessionIfNeeded(baseParams) {
    if (this.sessionStarted) return;
    this.sessionStarted = true;
    this.track("session_start", baseParams);
  }

  static track(event, params) {
    try {
      const gtag = window.gtag;
      if (!gtag) {
        if (this.debug) console.log("[analytics] gtag not ready", event, params);
        return;
      }
      if (this.debug) console.log("[analytics]", event, params);
      gtag("event", event, params || {});
    } catch (err) {
      if (this.debug) console.warn("[analytics] error", err);
      // swallow
    }
  }
}
